export default {
  partnerid: '506',
  defaultAvatar: {
    user: 'https://cmspic-10004025.image.myqcloud.com/b2cc8dd3-e8b3-4623-9b5e-bfe339d835c9',
    guwen:
      'https://cmspic-10004025.image.myqcloud.com/a056bede-9197-4f0f-a51f-6d04bb2df131'
  },
  // 直辖市
  provinceLevelCity: [
    {
      ID: '110000',
      NAME: '北京市',
      CityList: [
        {
          ID: '110100',
          NAME: '市辖区'
        },
        {
          ID: '110200',
          NAME: '县'
        }
      ]
    },
    {
      ID: '120000',
      NAME: '天津市',
      CityList: [
        {
          ID: '120100',
          NAME: '市辖区'
        },
        {
          ID: '120200',
          NAME: '县'
        }
      ]
    },
    {
      ID: '310000',
      NAME: '上海市',
      CityList: [
        {
          ID: '310100',
          NAME: '市辖区'
        },
        {
          ID: '310200',
          NAME: '县'
        }
      ]
    },
    {
      ID: '500000',
      NAME: '重庆市',
      CityList: [
        {
          ID: '500100',
          NAME: '市辖区'
        },
        {
          ID: '500200',
          NAME: '县'
        }
      ]
    }
  ]
}
